import React__default from 'react';
import cn from 'classnames';

const Progress = ({
  duration = undefined,
  ...props
}) => {
  let style;

  if (duration) {
    style = {
      animationDuration: `${duration}ms`
    };
  }

  const className = cn('bg-grey-light rounded block h-1 overflow-hidden w-full', props.className);
  const progressClassName = cn('yt-progress__bar block h-1', {
    "w-full before:h-1 before:bg-grey-dark before:block before:animate-[progress-indeterminate_2s_cubic-bezier(0.4,0,0.2,1)_infinite] before:content-[' ']": !duration,
    [`w-0 bg-grey-dark animate-[progress_linear]`]: duration
  });
  return React__default.createElement("span", Object.assign({}, props, {
    "data-taco": "progress",
    className: className
  }), React__default.createElement("span", {
    className: progressClassName,
    "data-taco": "progress-bar",
    style: style
  }));
};

export { Progress };
//# sourceMappingURL=Progress.js.map
